export default [
  {
    id: 268941278,
    node_id: "MDEwOlJlcG9zaXRvcnkyNjg5NDEyNzg=",
    name: "ICM",
    full_name: "mdial009/ICM",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/ICM",
    description:
      "Used the TensorFlow library to train the AI and based on data and take that data to classify an image.",
    fork: false,
    url: "https://api.github.com/repos/mdial009/ICM",
    forks_url: "https://api.github.com/repos/mdial009/ICM/forks",
    keys_url: "https://api.github.com/repos/mdial009/ICM/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/ICM/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/mdial009/ICM/teams",
    hooks_url: "https://api.github.com/repos/mdial009/ICM/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/ICM/issues/events{/number}",
    events_url: "https://api.github.com/repos/mdial009/ICM/events",
    assignees_url: "https://api.github.com/repos/mdial009/ICM/assignees{/user}",
    branches_url: "https://api.github.com/repos/mdial009/ICM/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/ICM/tags",
    blobs_url: "https://api.github.com/repos/mdial009/ICM/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/mdial009/ICM/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/mdial009/ICM/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/mdial009/ICM/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/mdial009/ICM/statuses/{sha}",
    languages_url: "https://api.github.com/repos/mdial009/ICM/languages",
    stargazers_url: "https://api.github.com/repos/mdial009/ICM/stargazers",
    contributors_url: "https://api.github.com/repos/mdial009/ICM/contributors",
    subscribers_url: "https://api.github.com/repos/mdial009/ICM/subscribers",
    subscription_url: "https://api.github.com/repos/mdial009/ICM/subscription",
    commits_url: "https://api.github.com/repos/mdial009/ICM/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/ICM/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/mdial009/ICM/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/ICM/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/mdial009/ICM/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/ICM/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/mdial009/ICM/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/ICM/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/mdial009/ICM/downloads",
    issues_url: "https://api.github.com/repos/mdial009/ICM/issues{/number}",
    pulls_url: "https://api.github.com/repos/mdial009/ICM/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/ICM/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/ICM/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/mdial009/ICM/labels{/name}",
    releases_url: "https://api.github.com/repos/mdial009/ICM/releases{/id}",
    deployments_url: "https://api.github.com/repos/mdial009/ICM/deployments",
    created_at: "2020-06-03T00:53:59Z",
    updated_at: "2020-07-11T00:26:53Z",
    pushed_at: "2020-07-11T00:26:51Z",
    git_url: "git://github.com/mdial009/ICM.git",
    ssh_url: "git@github.com:mdial009/ICM.git",
    clone_url: "https://github.com/mdial009/ICM.git",
    svn_url: "https://github.com/mdial009/ICM",
    homepage: "",
    size: 202,
    stargazers_count: 1,
    watchers_count: 1,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: "master",
  },
  {
    id: 267192475,
    node_id: "MDEwOlJlcG9zaXRvcnkyNjcxOTI0NzU=",
    name: "VirtualAssistant",
    full_name: "mdial009/VirtualAssistant",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/VirtualAssistant",
    description:
      "This is a Virtual Assistant program that gets the date, current time, Respond back with a random greeting, and return information on a person.",
    fork: false,
    url: "https://api.github.com/repos/mdial009/VirtualAssistant",
    forks_url: "https://api.github.com/repos/mdial009/VirtualAssistant/forks",
    keys_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/mdial009/VirtualAssistant/teams",
    hooks_url: "https://api.github.com/repos/mdial009/VirtualAssistant/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/issues/events{/number}",
    events_url: "https://api.github.com/repos/mdial009/VirtualAssistant/events",
    assignees_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/VirtualAssistant/tags",
    blobs_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/languages",
    stargazers_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/stargazers",
    contributors_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/contributors",
    subscribers_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/subscribers",
    subscription_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/subscription",
    commits_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/mdial009/VirtualAssistant/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/downloads",
    issues_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/labels{/name}",
    releases_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/deployments",
    created_at: "2020-05-27T01:37:31Z",
    updated_at: "2020-06-13T17:17:18Z",
    pushed_at: "2020-05-30T20:56:36Z",
    git_url: "git://github.com/mdial009/VirtualAssistant.git",
    ssh_url: "git@github.com:mdial009/VirtualAssistant.git",
    clone_url: "https://github.com/mdial009/VirtualAssistant.git",
    svn_url: "https://github.com/mdial009/VirtualAssistant",
    homepage: "",
    size: 39907,
    stargazers_count: 1,
    watchers_count: 1,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: "master",
  },
  {
    id: 267993365,
    node_id: "MDEwOlJlcG9zaXRvcnkyNjc5OTMzNjU=",
    name: "AI-Chat-Bot",
    full_name: "mdial009/AI-Chat-Bot",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/AI-Chat-Bot",
    description: 'a "Smart" Chat Bot Program',
    fork: false,
    url: "https://api.github.com/repos/mdial009/AI-Chat-Bot",
    forks_url: "https://api.github.com/repos/mdial009/AI-Chat-Bot/forks",
    keys_url: "https://api.github.com/repos/mdial009/AI-Chat-Bot/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/mdial009/AI-Chat-Bot/teams",
    hooks_url: "https://api.github.com/repos/mdial009/AI-Chat-Bot/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/issues/events{/number}",
    events_url: "https://api.github.com/repos/mdial009/AI-Chat-Bot/events",
    assignees_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/AI-Chat-Bot/tags",
    blobs_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/languages",
    stargazers_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/stargazers",
    contributors_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/contributors",
    subscribers_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/subscribers",
    subscription_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/subscription",
    commits_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/mdial009/AI-Chat-Bot/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/downloads",
    issues_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/labels{/name}",
    releases_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/deployments",
    created_at: "2020-05-30T02:16:59Z",
    updated_at: "2020-06-25T14:54:48Z",
    pushed_at: "2020-06-25T14:54:46Z",
    git_url: "git://github.com/mdial009/AI-Chat-Bot.git",
    ssh_url: "git@github.com:mdial009/AI-Chat-Bot.git",
    clone_url: "https://github.com/mdial009/AI-Chat-Bot.git",
    svn_url: "https://github.com/mdial009/AI-Chat-Bot",
    homepage: "",
    size: 5,
    stargazers_count: 1,
    watchers_count: 1,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: "master",
  },
  {
    id: 208252494,
    node_id: "MDEwOlJlcG9zaXRvcnkyMDgyNTI0OTQ=",
    name: "burghy-bites",
    full_name: "coding-hub-org/burghy-bites",
    private: false,
    owner: {
      login: "coding-hub-org",
      id: 43360008,
      node_id: "MDEyOk9yZ2FuaXphdGlvbjQzMzYwMDA4",
      avatar_url: "https://avatars2.githubusercontent.com/u/43360008?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/coding-hub-org",
      html_url: "https://github.com/coding-hub-org",
      followers_url: "https://api.github.com/users/coding-hub-org/followers",
      following_url:
        "https://api.github.com/users/coding-hub-org/following{/other_user}",
      gists_url: "https://api.github.com/users/coding-hub-org/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/coding-hub-org/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/coding-hub-org/subscriptions",
      organizations_url: "https://api.github.com/users/coding-hub-org/orgs",
      repos_url: "https://api.github.com/users/coding-hub-org/repos",
      events_url:
        "https://api.github.com/users/coding-hub-org/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/coding-hub-org/received_events",
      type: "Organization",
      site_admin: false,
    },
    html_url: "https://github.com/coding-hub-org/burghy-bites",
    description:
      "A web and mobile application for rating and reviewing food at SUNY Plattsburgh.",
    fork: false,
    url: "https://api.github.com/repos/coding-hub-org/burghy-bites",
    forks_url: "https://api.github.com/repos/coding-hub-org/burghy-bites/forks",
    keys_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/coding-hub-org/burghy-bites/teams",
    hooks_url: "https://api.github.com/repos/coding-hub-org/burghy-bites/hooks",
    issue_events_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/events",
    assignees_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/branches{/branch}",
    tags_url: "https://api.github.com/repos/coding-hub-org/burghy-bites/tags",
    blobs_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/languages",
    stargazers_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/stargazers",
    contributors_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/contributors",
    subscribers_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/subscribers",
    subscription_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/subscription",
    commits_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/merges",
    archive_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/downloads",
    issues_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/labels{/name}",
    releases_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/coding-hub-org/burghy-bites/deployments",
    created_at: "2019-09-13T11:36:56Z",
    updated_at: "2019-12-05T22:18:25Z",
    pushed_at: "2020-07-31T21:43:12Z",
    git_url: "git://github.com/coding-hub-org/burghy-bites.git",
    ssh_url: "git@github.com:coding-hub-org/burghy-bites.git",
    clone_url: "https://github.com/coding-hub-org/burghy-bites.git",
    svn_url: "https://github.com/coding-hub-org/burghy-bites",
    homepage: null,
    size: 1664,
    stargazers_count: 2,
    watchers_count: 2,
    language: "TypeScript",
    has_issues: true,
    has_projects: false,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 10,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 4,
    license: null,
    forks: 10,
    open_issues: 4,
    watchers: 2,
    default_branch: "master",
  },
];
